import { userEventsReducer, userReducer, userTicketsReducer } from './reducers';

export const { updateAccount, phoneCurrentUpdate, sendPhoneCode, clear, userInitiate } = userReducer.actions;
export const { clearEvents, initDistributionEvents } = userEventsReducer.actions;
export const { clearTickets, initiateTickets } = userTicketsReducer.actions;
